import UltMeta, { Meta } from "./UltMeta/index";

/**
 * 费用类型
 */
class ServiceFeeCostType extends UltMeta {
    SERVICE_FEE = new Meta(1, "业务服务费");
    REGULATORY_FEE = new Meta(2, "监管服务费");
}

export const SERVICE_FEE_COST_TYPE = new ServiceFeeCostType();

/**
 * 付款方式
 */
class ServiceFeePaymentWay extends UltMeta {
    BANK_TRANSFER = new Meta(2, "银行转账");
}

export const SERVICE_FEE_PAYMENT_WAY = new ServiceFeePaymentWay();

/**
 * 状态 管理后台的服务费管理
 */
class ServiceFeeStateAdmin extends UltMeta {
    PENDING_CONFIRMATION = new Meta(1, "待确认");
    COMPLETED = new Meta(2, "已完成");
}

export const SERVICE_FEE_STATE_ADMIN = new ServiceFeeStateAdmin();

/**
 * 用户的付款管理
 */
class ServiceFeeStatePC extends UltMeta {
    PENDING_CONFIRMATION = new Meta(1, "确认中");
    COMPLETED = new Meta(2, "已完成");
    REJECTED = new Meta(3, "已驳回");
}

export const SERVICE_FEE_STATE_PC = new ServiceFeeStatePC();
